import { render, staticRenderFns } from "./MuonitusAsetukset.vue?vue&type=template&id=92ba0f4a"
import script from "./MuonitusAsetukset.vue?vue&type=script&lang=js"
export * from "./MuonitusAsetukset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports